<script>
  import { urlServeur } from "../components/conf";
  import Spinner from "../components/ToolsSpinner.svelte";

  let promise;
  export let id; // id salarié
  let totalSalaire = []; // aide au calcul du % augmentation salaire
  let x = -1; //aide au calcul du % augmentation salaire calcul sur année precedente

  /**
   *
   */
  const fecthSyntheseSal = async () => {
    const response = await fetch(
      urlServeur + "/api_employe/employe_progres_salaire/id/" + id
    );
    const rest = await response.json();
    //console.dir(rest.payload);

    return rest.payload;
  }; // (); // ATTENTIOB les () important => declanche l'execution de la methode

  /**
   * calcul du % augmentation salaire calcul sur année precedente
   * @param salaire
   * @param prime : plus utilisé
   * @param autre : plus utilisé
   */
  const calculPercent = (salaire, prime, autre) => {
    totalSalaire.push(prime + autre + salaire);
    x += 1;
    if (x == 0) {
      //premier element
      //console.log(" A- " + totalSalaire);
      return 0;
    } else {
      return Math.round(
        ((totalSalaire[x] - totalSalaire[x - 1]) * 100) / totalSalaire[x - 1],
        2
      );
    }
  };

  promise = fecthSyntheseSal();
</script>

{#await promise}
  <Spinner />
{:then elements}
  <table class="table table-responsive table-sm">
    <thead class="table-dark">
      <tr>
        <td>année</td>
        <td>salaire</td>
        <td>prime</td>
        <td>autre</td>
        <td>sal.total</td>
        <td>%augm(1)</td>
      </tr>
    </thead>
    <tbody>
      {#each elements as element}
        <tr>
          <td>{element.annee}</td>
          <td class={element.augmentation === 1 ? "augmentation" : ""}
            >{Math.round(element.salaire / 12, 0)}</td
          >
          <td>{Math.round(element.prime, 2)}</td>
          <td>{element.autre}</td>
          <td
            >{new Intl.NumberFormat("fr-FR").format(
              Math.round(element.salaire + element.autre + element.prime)
            )}</td
          >
          <td> {calculPercent(element.salaire, 0, 0)} %</td>
        </tr>
      {/each}
    </tbody>
  </table>
  <span class="note text-secondary"
    >(1) calculé sur sal.brut année précédente (hors primes Etc...)</span
  >
{/await}

<style>
  .table {
    font-size: 0.65em;
  }
  .augmentation {
    background-color: rgb(33, 223, 96);
  }
  .note {
    font-size: 0.6em;
    font-style: italic;
  }
</style>
